/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 73ac5de52252
 */

import * as z from "zod";

export type UpdateTriggerRequest = { new_uri: string };

export const UpdateTriggerRequest$zodSchema: z.ZodType<UpdateTriggerRequest> = z
  .object({
    new_uri: z.string().describe(
      "The updated URL that will receive the notification response.",
    ),
  });
